import { registerWeapon } from './registry';
import { DEFAULT_CRATER } from '../terrain/crater-shapes';

export const BOUNCER = registerWeapon({
  id: 'bouncer',
  name: 'Bouncer',
  description: '3 bounces before detonation. Trick shot master.',
  tier: 'COMMON',
  rarity: 'common',
  projectileRadius: 7,
  projectileSpeed: 0.55,
  color: 0x44ddff,
  gravity: 0.15,
  bounces: 3,
  bounceEnergyRetention: 0.80,
  damage: 25,
  blastRadius: 70,
  knockbackMult: 0.07,
  knockbackRadius: 1.2,
  shakeIntensity: 3.0,
  particleScale: 1.2,
  craterShape: DEFAULT_CRATER,
});
